export default __webpack_public_path__ + "static/media/tick.212dea4c.svg";